import React from 'react';
import { GOLD, DARK, BLACK } from '../constants/theme';
import { IMGS } from '../constants/images';
import SecLabel from './ui/SecLabel';
import GoldBtn from './ui/GoldBtn';

const About: React.FC = () => (
  <section id="about" style={{ background:DARK, padding:'90px 8vw', display:'flex', gap:56, alignItems:'center', flexWrap:'wrap' }}>
    <div style={{ flex:'1 1 360px', position:'relative' }}>
      <img src={IMGS.about} alt="Our chef" style={{ width:'100%', maxWidth:460, display:'block', filter:'brightness(0.86)', position:'relative', zIndex:1 }}/>
      <div style={{ position:'absolute', bottom:-16, right:-16, width:160, height:160, border:`2px solid ${GOLD}`, zIndex:0 }}/>
      <div style={{ position:'absolute', top:-16, left:-16, width:86, height:86, border:`1px solid rgba(196,152,50,0.32)`, zIndex:0 }}/>
      <div style={{ position:'absolute', bottom:22, left:-34, background:GOLD, padding:'16px 22px', zIndex:2 }}>
        <div style={{ fontFamily:'Cormorant Garamond', fontSize:32, fontWeight:600, color:BLACK, lineHeight:1 }}>10+</div>
        <div style={{ fontFamily:'Montserrat', fontSize:8, letterSpacing:2, color:'rgba(0,0,0,0.62)', textTransform:'uppercase' }}>Years of Excellence</div>
      </div>
    </div>
    <div style={{ flex:'1 1 360px' }}>
      <SecLabel text="OUR STORY"/>
      <h2 style={{ fontFamily:'Cormorant Garamond', fontSize:'clamp(28px,3.6vw,40px)', fontWeight:300, color:'#fff', lineHeight:1.22, marginTop:6 }}>
        Celebrating Every Occasion with <br/><em style={{ color:GOLD }}>Exceptional</em> Food
      </h2>
      <p style={{ color:'rgba(255,255,255,0.56)', fontFamily:'Montserrat', fontSize:12, lineHeight:1.9, marginTop:16 }}>
      At Gowjee Caterers, we combine rich culinary traditions with warm hospitality to create unforgettable dining experiences. For years, we have proudly served delicious meals at weddings, family gatherings, and corporate events.
      </p>
      <p style={{ color:'rgba(255,255,255,0.56)', fontFamily:'Montserrat', fontSize:12, lineHeight:1.9, marginTop:12 }}>
      Our skilled chefs prepare every dish using fresh, locally sourced ingredients, ensuring authentic flavors and a memorable experience for every guest.
      </p>
      <div style={{ display:'flex', flexWrap:'wrap', gap:12, marginTop:26 }}>
        {['Authentic Flavors','100% Fresh Ingredients','Bespoke Menus'].map(f => (
          <div key={f} style={{ display:'flex', alignItems:'center', gap:8 }}>
            <div style={{ width:16, height:16, border:`1px solid ${GOLD}`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
              <div style={{ width:6, height:6, background:GOLD }}/>
            </div>
            <span style={{ fontFamily:'Montserrat', fontSize:10, color:'rgba(255,255,255,0.62)' }}>{f}</span>
          </div>
        ))}
      </div>
      <div style={{ marginTop:30 }}><GoldBtn href="#contact">Discover More</GoldBtn></div>
    </div>
  </section>
);

export default About;